<script>
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

// Custom Components
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Bed section Component

export default {
  page: {
    title: "Bed Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
  },
  data() {
    return {
      title: "Bed Type",
      isLoading: true,
      table: {
        tableData: [],
      },
      bed: {
        name: "",
        short_name: "",
      },
      badTitle: "Add New Bed Type",
      isBtnLoading: false,
      submitted: false,
      isEdit: false,
      badId: "",
    };
  },
  validations: {
    bed: {
      name: {
        required,
      },
      short_name: {
        required,
      },
    },
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getBadListData();
  },
  methods: {
    // Method is us for get bed data
    async getBadListData() {
      try {
        const response = await UserService.getBadList();
        this.table.tableData = response;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is use for add new bed
    badForm() {
      this.$bvModal.show("bed-modal");
    },
    // Method is use add new category on button ok click
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    // Method is use add new category
    async handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        this.bed = { ...this.bed, hotel: this.hotel.id };
        if (this.isEdit !== false) {
          try {
            const response = await UserService.updateBad(this.bed, this.badId);
            this.table.tableData = this.table.tableData.map((item) => {
              if (item.id === response.id) {
                item = response;
              }
              return item;
            });
            this.$bvModal.hide("bed-modal");
            Middleware.notification("Successfully updated !!", "success");

            this.isBtnLoading = false;
            this.resetModal();
          } catch (error) {
            this.isBtnLoading = false;
            errorHandler(error);
          }
        } else {
          try {
            const response = await UserService.createBad(this.bed);
            this.$bvModal.hide("bed-modal");
            Middleware.notification("Successfully added !!", "success");

            this.isBtnLoading = false;
            this.table.tableData.push(response);
            this.resetModal();
          } catch (error) {
            this.isBtnLoading = false;
            errorHandler(error);
          }
        }
      }
    },
    // Method is use for reset modal
    resetModal() {
      this.bed = {
        name: "",
        short_name: "",
      };
      this.submitted = false;
      this.isEdit = false;
      this.badTitle = "Add New Bed Type";
      this.isBtnLoading = false;
      this.badId = "";
    },
    // Method is use for edit bed
    editBad(data) {
      this.isEdit = !this.isEdit;
      this.$bvModal.show("bed-modal");
      this.badId = data.id;
      this.badTitle = "Update Bed Type";
      this.bed.name = data.name;
      this.bed.short_name = data.short_name;
    },
    // Method is use for delete category
    deleteBad(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteBad(id).then(
            () => {
              this.table.tableData = this.table.tableData.filter(
                (item) => item.id !== id
              );
              Middleware.notification("Successfully deleted !!", "danger");
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    // method is use for cancel submit form
    cancelSubmit() {
      this.$bvModal.hide("bed-modal");
      this.resetModal();
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="badForm"
      text="Add New Bed Type"
      :isButton="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <div class="table-responsive mb-0">
                  <!-- Table -->
                  <table
                    class="table table-hover mb-0 common-table"
                    ref="my-table"
                    v-infinite-scroll="getBadListData"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Name</th>
                        <th>Short Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isLoading">
                      <tr v-for="(item, index) in 20" :key="index">
                        <td class="placeholder-glow" v-for="no in 3" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in table.tableData" :key="index">
                        <td @click="editBad(data)">
                          {{ data.name }}
                        </td>
                        <td @click="editBad(data)">
                          {{ data.short_name }}
                        </td>
                        <td>
                          <div slot="actions" class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt me-2 text-success"
                              v-b-popover.hover="'Edit building'"
                              @click="editBad(data)"
                            ></i>
                            <i
                              v-b-popover.hover="'Delete building'"
                              class="mdi mdi-trash-can ms-2 fs-5 text-danger"
                              @click="deleteBad(data.id)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The model is for view image of guest experience -->
    <b-modal
      id="bed-modal"
      :title="badTitle"
      centered
      hide-footer
      title-class="font-18"
      @hidden="resetModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="Name" label-for="name-input" class="mb-3">
          <p slot="label" class="mb-2">
            Bed Name <span class="text-danger">*</span>
          </p>
          <b-form-input
            id="name-input"
            v-model="bed.name"
            placeholder="Ex : Kind Size Bed"
            autocomplete="off"
            type="text"
            :class="{
              'is-invalid': submitted && $v.bed.name.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.bed.name.required">Bed name is required.</span>
          </div>
        </b-form-group>
        <b-form-group
          label="Short name"
          label-for="short-name-input"
          class="mb-3"
        >
          <p slot="label" class="mb-2">
            Bed Short name <span class="text-danger">*</span>
          </p>
          <b-form-input
            id="short-name-input"
            v-model="bed.short_name"
            placeholder="Ex : KB"
            autocomplete="off"
            type="text"
            :class="{
              'is-invalid': submitted && $v.bed.short_name.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.bed.short_name.required"
              >Bed short name is required.</span
            >
          </div>
        </b-form-group>

        <div class="row">
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel
            </b-button>
            <b-button
              class="float-end"
              variant="outline-primary"
              @click="handleOk"
              :class="{ disabled: isBtnLoading }"
            >
              <i
                v-if="isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
